module.exports = __webpack_public_path__ + "static/img/cross_board.c419cd6a.png";